<template>
  <div>
    <dialog-edit-address></dialog-edit-address>
    <address-form :address="address" read_only></address-form>
  </div>
</template>

<script>

  export default {
    name: 'ShowDepotAddress',
    props: {
      address: {
        type: Object,
      }
    },
    components: {
      DialogEditAddress: () => import('../register/edit/DialogEditAddress'),
      AddressForm: () => import('@/_backoffice/_registrations/components/shared/forms/AddressForm.vue'),
    },
    data() {
      return {
      }
    },
    methods: {
    },
    computed: {
    },
    watch: {
    },
  }
</script>

<style lang="scss" scoped>
.btn{

}
</style>
